const cn_solutions = require('./ru_solutions')
const cn_products = require('./ru_products')
module.exports = {
  companyName: 'Zhongling международная логистика',
  header: {
    home: 'Главная',
    news: 'Новости',
    solution: 'Услуги',
    partner: 'Наши партнёры',
    product: 'Новости',
    aboutUs: 'О компании',
    contactUs: 'Контакты',
    productMenu: {
      logistics: 'Управление логистикой',
      warehouse: 'Управление складом',
      container: 'Управление контейнерами',
      supplyChain: 'Управление снабженческой цепочкой',
    },
    solutionMenu: {
      airport: 'Авиаперевозки',
      education: 'Мультимодальные перевозки',
      port: 'Морские перевозки',
      traffic: 'Жд перевозки'
    }
  },
  common: {
    learnMore: 'узнай больше',

    viewVideo: 'смотреть видео'
  },
  home: {
    banner: {
      banner1Info: 'Идем по Шелковому пути, чтобы создать лучшее завтра',

      banner2Info: 'все, что связано с интеллектуальным будущим',

      banner3Info: 'сердцевинная энергия',

      banner4Info: 'интеллектуальная конференция'
    },

    product: 'Международные перевозки',
    logistics: 'Управление логистикой',
    logisticsProject0: 'Комплексная логистика',
    logisticsDetail0: 'Выберите подходящий для Вас вид транспорта.',
    logisticsProject1: ' Международные мультимодальные перевозки',
    logisticsDetail1:  'Это транспортировка грузов несколькими видами транспорта. включает Море+ЖД, Авто+ЖД и т.д ',
    logisticsProject2: 'Международные железнодорожные перевозки',
    logisticsDetail2: 'В ответ на великую инициативу « одна дорога во всем районе» предлагается полноценный железнодорожный транспорт из Китая в Россию, Европу и Центральную Азию',
    logisticsProject3: 'Инженерная логистика',
    logisticsDetail3: 'Для особых грузов, таких как крупные детали, тяжелое оборудование, машины, точные приборы и т.д.',
    logisticsProject4: 'Международные автоперевозки',
    logisticsDetail4: 'Международные автомобильные перевозки грузов наиболее выгодны, если требуется доставить товары на небольшие расстояния. ',
    logisticsProject5: 'Международная электрокоммерческая логистика',
    logisticsDetail5: 'Помочь международной электрокоммерческой компании повысить рыночную конкурентоспособность',
    logisticsProject6: 'Международные авиаперевозки',
    logisticsDetail6: 'Чартерные и индивидуализированные услуги по заказу.',
    logisticsProject7: 'Международные морские перевозки',
    logisticsDetail7: 'морские контейнерные грузы, морские и импортные услуги, морские перевозки массовых грузов, баржа в китайском порту.',

    warehouse: 'Управление складом',
    warehouseProject0: 'Складирование + Доставка + Система',
    warehouseDetail0: 'Однопозиционное обслуживание',
    warehouseProject1: 'Хранение в налоговой зоне',
    warehouseDetail1: 'Имеет современный Центр хранения и логистики, опираясь на богатый опыт управления складом и передовое оборудование, международные стандартные операции, зрелые решения и профессиональные группы управления логистикой, чтобы предоставить клиентам удовлетворительные складские логистические услуги',
    warehouseProject2: 'Услуги склада за границей',
    warehouseDetail2: 'В зарубежных городах, таких как Гамбург, Варшава, Москва, Ташкент и Алматы, были созданы зарубежные склады, созданы центры управления складами и распределения, а услуги по управлению складами постоянно оптимизируются и модернизируются.',
    warehouseProject3: 'Международный электроторговый склад',
    warehouseDetail3: 'Для трансграничных продавцов электрических услуг, чтобы обеспечить полный спектр, высокое качество, долговечность и высокую стоимость трансграничных логистических складских услуг, помогать трансграничным электрическим продавцам оптимизировать цепочку поставок, снизить логистические издержки, избежать риска потери товаров, не беспокоиться о поставках, большой объем продаж продукции.',
    warehouseProject4: 'Заказная служба доставки',
    warehouseDetail4: 'Управление складированием, заказы на выход, вход в хранилище, очистка от таможенного оформления и последний километр в конце пути, для доставки клиентам на дом, полный логистический контроль информации.',

    container: 'Управление контейнерами',
    containerProject0: 'Контейнер',
    containerDetail0: 'Собственный контейнер, чтобы снизить транспортные расходы.',
    containerProject1: 'Складские и ремонтные услуги',
    containerDetail1: 'Для предоставления услуг по аренде и складированию контейнеров в странах',
    containerProject2: 'Аренда контейнеров',
    containerDetail2: 'Усовершенствованная информационная система для предоставления высококачественных и эффективных услуг',
    containerProject3: 'Продажа подержанных контейнеров',
    containerDetail3: 'имеет опытную специализированную команду контейнерных служб',
    containerProject4: 'Агентирование контейнеров',
    containerDetail4: 'Имеется несколько специалистов, занимающихся контейнерными операциями, и технический персонал по IT - менеджменту',

    supplyChain: 'Управление снабженческой цепочкой',
    supplyChainProject0: 'Агентирование контейнеров',
    supplyChainDetail0: 'Однопозиционное обслуживание',
    supplyChainProject1: 'Импортная и экспортная таможенная декларация',
    supplyChainDetail1: 'компания получает квалификацию первого класса экспедиторского Агентства, выданную министерством национальной торговли, и обладает международным судовым Агентом, бескорабельным перевозчиком и профессиональными (контейнерными) дорожными лицензиями, выдаваемыми министерством транспорта',
    supplyChainProject2: 'Агент по продажам за границей',
    supplyChainDetail2: 'Мы являемся членом крупнейшей в китае международной железнодорожной транспортной платформы континентальный мост, а также членом китайской ассоциации международных грузовых перевозок (Сифа)',
    supplyChainProject3: 'Агент закупки',
    supplyChainDetail3: 'Лучше закупать для зарубежных заказчиков различные отличные китайские товары.',
    supplyChainProject4: 'Финансирование производственно - сбытовых цепей',
    supplyChainDetail4: 'Предоставляет услуги в области логистики, расчетов по финансовым средствам, обработки информации и т.д., помогает клиентам в реализации зарубежных продаж и доставки, снижает запасы канала, контролирует риски сделок, ускоряет оборачиваемость кредита и повышает конкурентоспособность клиента',

    describe: 'Компания Guangdong Quanxiantong International Supply Chain Co., Ltd. расположена в Шэньчжэне, особой экономической зоне Южные ворота в Китае.Основным направлением деятельности компании является железнодорожный экспресс Китай-Европа, охватывающий Китай-Европу, Китай-Россию и Среднюю Азию. железнодорожные контейнерные перевозки, внутренние торговые железнодорожные перевозки, морские перевозки, железнодорожный транспорт и другие области.',

    robot: 'интеллектуальный робот',

    title1: 'интеллектуальное взаимодействие для будущего',

    tip1: 'AI интеллектуальный робот, способный использовать сцену под несколькими линиями для удовлетворения потребностей различных пользователей',

    guiding: 'интеллектуальный робот наведения',

    tip2: 'может выполнять такие функции, как распознавание лица, свободный выбор места посещения и т.д.',

    educationRobot: 'интеллектуальный образовательный робот',

    tip3: 'имеет много функций, таких как обучение, сопровождение, посещаемость, управление голосом и т.д.',

    security: 'интеллектуальный робот безопасности',

    tip4: 'может осуществлять самостоятельное планирование патрулирования, локальный интеллектуальный видеоанализ и другие функции ',

    delivery: 'интеллектуальный робот доставки',

    tip5: 'может быть реализован интеллигентный биологический признак для разблокирования, отправки объектов и других функций,',

    home: 'интеллектуальный домашний робот',

    tip6: 'может быть реализован ряд функций, таких как офисный помощник и домохозяйка',

    terminal: 'интеллектуальный терминал',

    title2: 'интеллектуальный терминал облегчает жизнь',

    tip7: 'несколько интеллектуальных терминалов для удовлетворения различных потребностей вашей жизни и работы в сцене',

    eye: 'интеллектуальный кошачий глаз',

    tip8: 'ржавчина серии интеллектуальных кошачьих глаз, чтобы открыть перед дверью глаза',

    access: 'интеллектуальный вход',

    tip9: 'для достижения максимальной скорости распознавания лиц, чтобы открыть замок, табель и другие функции ',

    aDAS: 'автомобильное вспомогательное управление',

    tip10: 'оригинальный интеллектуальный чип, датчик и интеллектуальный алгоритм, чтобы сделать путешествие более безопасным',

    access2: 'интеллектуальный термометр',

    tip22: 'мониторинг температуры тела в реальном времени, а также поддержка распознавания и идентификации лиц',

    chip: 'интеллектуальный модуль',

    title3: 'интеллектуальный модуль безгранично мощный',

    tip11: 'использование технологии AI для расширения возможностей людей, чтобы принести большую силу',

    neuromorphic: 'интеллектуальный терминальный щит',

    tip12: 'может удовлетворить множество встроенных продуктов AI с высокой производительностью самостоятельной разработки',

    module: 'учиться на сердцевине интеллектуальный модуль ',

    tip13: 'Проектирование высокопроизводительной архитектуры, локальный интеллект + обучение в режиме онлайн',

    vehicle: 'интеллектуальная патрульная машина',

    title4: 'интеллектуальный обход эффективно и безопасно',

    tip14: 'интеллектуальный патрульный автомобиль, который может эффективно, безопасно и разумно выполнять различные задачи по инспектированию',

    trolley: 'интеллектуальный патруль',

    tip15: 'базовая версия отличается от продвинутой версии для настройки, которая удовлетворяет различным требованиям',

    coreTechnology: 'Сфера бизнеса',

    message1: 'Международные комбинированные перевозки из Центральной Европы и Центральной Азии: доставляем компании со всей страны в Гуанчжоу, Чжэнчжоу, Сиань, Чэнду, Чунцин и другие места и перевозим их в Европу (Малайзия, Лодзь, Тилбург, Дуйсбург, Гамбург, Будапешт) ) железнодорожным поездом и другими городами), Центральная Азия (Алматы, Ташкент и другие города) международные мультимодальные логистические услуги, китайско-российские международные мультимодальные транспортные продукты: предоставляем компании со всей страны в Шэньчжэнь, Гуанчжоу, Чжэнчжоу, Сиань, Чэнду, Чунцин и другие места, через международные мультимодальные логистические услуги для железнодорожных поездов в Россию (вся территория).',

    localIntelligent: 'локальная интеллектуальная технология',

    face: 'Defense Analysis Technology',

    action: 'методы анализа поведения',

    defect: 'метод анализа дефектов',

    target: 'общие методы анализа целей',

    hxVideo: 'Video Analysis Technology',

    hxData: 'метод анализа данных',

    solution: 'Наши услуги',
    airport: 'Авиаперевозки',
    apron: 'Международные авиаперевозки',

    park: 'интеллектуальный парк',

    message2: 'парк мудрости / дом мудрости / офис мудрости / сообщество мудрости',

    education: 'Мультимодальные перевозки',
    message3: 'Международные мультимодальные перевозки',

    medical: 'мудрость медицины',

    message4: 'мудрый госпиталь / AI',

    detection: 'мудрость обнаружения',

    message5: 'высокоточная промышленная съемка / обнаружение дефектов поверхности полосы',

    port: 'Морские перевозки',
    message6: 'Международные морские перевозки',
    traffic: 'Жд перевозки',
    message11: 'Международные железнодорожные перевозки ',
    moreSolution: 'Больше услуг ',
    partner: 'Наши партнёры',

    network: 'Group Network',

    message7: 'китай и шанхай, шэньчжэнь, чунцин, нанкин отдела активных подготовительных мероприятий в гуанчжоу, Пекин, шанхай, шэньчжэнь, чунцин, нанкин, формирование внутренней и внешней ассоциации, север и Юг в ответ на призыв ',

    yantai: 'яньтай',
    message8: {
      message80: 'в процессе подготовки',

    },
    yangzhou: 'янчжоу',
    message9: {
      message90: 'в процессе подготовки',

    },
    singapore: 'Сингапур',

    message10: 'group sector',

    beijing: 'пекин',

    shanghai: 'шанхай',

    shenzhen: 'гуанчжоу',

    chongqing: 'чунцин',

    nanjing: 'нанкин',

    none: 'в процессе подготовки',

    mainLine: 'Основная линия',
    chinaRailwayExpress: 'Китайский железнодорожный экспресс',
    chinaRailwayExpress1: 'Китай, Беларусь и Украина',
    chinaRailwayExpress2: 'Россия, Беларусь, Украина',
    chinaRailwayExpress3: 'Центральная Азия Южная Азия Западная Азия',
    chinaRailwayExpress4: 'Узбекистан, Казахстан, Кыргызстан, Непал, Иран, Стамбул',
    chinaRailwayExpress5: 'Европа',
    chinaRailwayExpress6: 'Мангейм, Прага, Славкув, Тилбург, Нюрнберг, Милан, Иммингем',

    seaRail: 'Комбинированные морско-железнодорожные перевозки',
    seaRail1: 'Гуанчжоу--Нинбо',
    seaRail2: '(Zengcheng West, международный порт Гуанчжоу, порт Наньша)',
    seaRail3: 'Дунгуань--Циндао',
    seaRail4: '(порт Даланг)',

    schedule: 'расписание',
    columnWeek: 'колонка/неделя',
    aging: 'старение',
    day: 'день',
    hotLine: 'популярные маршруты',

    hotLine1: 'Zengcheng West/Порт Наньша/Международный порт Гуанчжоу/Даланг',
    hotLine11: 'Гуоси/Шанькоу/Эрлиан/Маньчжурия',
    hotLine12: 'Россия/Беларусь',
    hotLine13: 'введение линии',
    // hotLine14: 'Линия может начинаться из Западного Цзэнчэна/порта Наньша/международного порта Гуанчжоу/Даланга, проходить через Гуози/Шанькоу/Эрлянь/Маньчжурию и, наконец, достигать России/Беларуси.',
    hotLine14: '',
    hotLine15: 'С тех пор, как в 2013 году была выдвинута инициатива «Один пояс, один путь», Сианьский международный порт в полной мере использовал преимущества географического положения Сианя и активно изучал возможность строительства внутренних каналов международной торговли. , открылся железнодорожный экспресс Китай-Европа «Чанъань».',

    hotLine2: 'Сиань',
    hotLine21: 'Госс／Алашанькоу',
    hotLine22: 'Россия/Шушале/Средняя Азия',
    hotLine23: 'введение линии',
    // hotLine24: 'Выезд из страны через Алашанькоу или Гос в Синьцзяне, Китай, прохождение через Казахстан, Россию и Беларусь и, наконец, прибытие в Варшаву, Польша, прохождение через 5 стран, весь путь составляет 9048 километров, и ожидается, что он прибудет в пункт назначения. через 12 дней.',
    hotLine24: '',
    hotLine25: 'В настоящее время Китайско-Европейский железнодорожный экспресс «Чанъань» достиг 15 основных линий в Среднюю Азию и Европу, охватывая 45 стран и регионов вдоль «Пояса и пути», и построил линию, соединяющую Среднюю Азию, Западную Азию и Южная Азия, излучающая внутренние районы Европы, международный логистический канал.',

    hotLine3: 'Порт Наньша',
    hotLine31: 'Госс',
    hotLine32: 'пять стран Центральной Азии',
    hotLine33: 'введение линии',
    hotLine34: 'Поезд Наньша Порт-Госи-Центральная Азия отличается фиксированным временем отправления, стабильным временем движения и низкой стоимостью. Подчеркните, что поезда, отправляющиеся туда и обратно, имеют разные пути туда и обратно, и строго рассчитывайте время стыковки поездов для смены пути.',

    hotLine4: 'Чэнду/Чунцин',
    hotLine41: 'Госс／Алашанькоу',
    hotLine42: 'Европа/Россия',
    hotLine43: 'введение линии',
    // hotLine44: 'Отправляясь со станции Чэнсян в Чэнду, выезжая из страны из Алашанькоу или Госса, проезжая через Казахстан, Россию, Беларусь и заканчивая станцией Лодзь в Польше, общее расстояние составляет 9965 километров, а время в пути - около 14 дней. Источниками товаров в основном являются ИТ-продукты местного производства и другие экспортные товары.',
    hotLine44: '',
    hotLine45: 'Название Yuxinou происходит от совместного соглашения железнодорожных и таможенных департаментов шести стран вдоль маршрута: «Yu» относится к Чунцину, «Xin» относится к Алашанькоу в Синьцзяне, а «Ou» относится к Европе, вместе называемой «Yuxinou». ". Будучи городом Чунцин, официальное открытие в марте 2011 года китайско-европейского железнодорожного экспресса (Юсиноу) является одной из важных стратегий создания внутреннего открытого высокогорья.',

    hotLine5: 'Ухань',
    hotLine51: 'Алашанькоу',
    hotLine52: 'Европа/Россия',
    hotLine53: 'введение линии',
    // hotLine54: 'Отправление со станции Уцзяшань в Ухане, выезд из страны через Алашанькоу или Гос, проезд через Казахстан, Россию, Беларусь и прибытие в соответствующие города Польши, Чехии, Словакии и других стран, весь путь составляет около 10 700 километров, а время в пути составляет около 15 дней.',
    hotLine54: '',
    hotLine55: 'С начала Китайского железнодорожного экспресса (Ухань) только одна линия из Уханя в Пардубице, Чешская Республика, в настоящее время существует 37 стабильных трансграничных транспортных линий в Китае и Европе, охватывающих 40 стран и 107 городов Евразии, постепенно образуя « Канальная параллельная, многоточечная прямая международная система логистической сети.',

    hotLine6: 'Чжэнчжоу',
    hotLine61: 'Госс／Алашанькоу',
    hotLine62: 'Европа/Россия',
    hotLine63: 'введение линии',
    // hotLine64: 'Отправляясь со станции Путянь в Чжэнчжоу, выезжая из страны из Алашанькоу или Госи, проезжая через Казахстан, Россию, Беларусь, Польшу до станции Гамбург в Германии, весь путь составляет 10 245 километров, а время в пути - от 11 до 15 дней.',
    hotLine64: '',
    hotLine65: 'Первый международный железнодорожный грузовой поезд Чжэнчжоу-Европа был запущен 18 июля 2013 года, открыв «Шелковый путь на суше» между Центральными равнинами и Европой. Количество поездов железнодорожного экспресса Чжэнчжоу составляет «80001 раз», что является «№ 1» среди грузовых поездов со всей страны в Европу.',

  },
  aboutUs: {
    us: 'о нас',
    company: 'о компании',
    news: 'информация',
    contact: 'связаться с нами',
    companyCondtion: 'Корпоративная среда',
    companyActivity: 'Деятельность компании',
    logo: 'Весь международный',

    message0: {
      message01: 'Гуандунская международная цепочка поставок с ограниченной ответственностью расположена в районе Байюнь, г. гуанчжоу, Китай, зарегистрированные средства в размере 20 млн. юаней, компания получила квалификацию первого класса экспедиторского Агентства, выданную министерством коммерции, имеет « международный судовой агент», « бескорабельный перевозчик» и специальные (упаковочные) разрешения на автомобильный транспорт и другие отрасли промышленности,В то же время является членом Ассоциации « континентальный мост» (крупнейшей в мире платформы для трансграничных перевозок в секторе международной железнодорожной логистики) и китайской ассоциации международных перевозок (Сифа).\n для того чтобы позитивно откликнуться на стратегическое решение и содействие страны один район, компания сосредоточила внимание на товарах из страны в Европу, россию и Центральную Азию, включая смешанные перевозки и складское хранение железнодорожных, морских, воздушных, морских и железных дорог и карт.В то же время, чтобы быстрее и лучше интегрироваться в международные связи, компания придерживается современной концепции логистики Интеграция управления производственно - сбытовыми цепочками, чтобы получить высококачественные услуги, чтобы завоевать доверие многих клиентов.\n компания имеет отличные профессиональные группы и эффективные и быстрые оперативные модели, в соответствии с принципами честности, безопасности, быстрых и профессиональных, для клиентов постоянно оптимизировать логистику различных звеньев, снизить логистические расходы, для внутренних и иностранных клиентов железной дороги, автомобильных, морских и таможенных деклараций, складирования, погрузки, хранения контейнеров и другие  общие логистические услуги, чтобы заложить хорошую основу для развития компании,постоянно предлагать клиентам лучшие решения.\n',
    },
    mission: 'наша миссия',

    tip: 'Идем по Шелковому пути, чтобы создать лучшее завтра',

    vision: 'наше видение',

    tip1: 'вспомогательное развитие логистики в районе',

    culture: 'корпоративная культура',

    tip2: 'Мы быстро продвигаемся вперед',
    message1: {


      message10: 'инспекция в провинции гуандун',

      message11: 'министерство торговли министр Син инспекции,',

      message12: 'инспекция секретаря провинциального комитета провинции гуандун',

      message13: 'промежуточный Международный и китайский контракт',
    },
    tip3: 'наша сеть быстро формируется',

    city1: 'Шэньчжэнь',

    add1: 'К. C1009, Э. 10, Корпус С, промышленный парк Hengboli Rongfeng, улица Xuegangbei, район Longhua, Шэньчжэнь',

    city2: 'янчжоу',

    add2: '505 - 1, улица к западу от янцзы, янчжоу, провинции цзянсу, китай ',

    city3: 'Shenzhen',

    add3: 'Сингапурский коридор развития 2, здание Vision Exchange 35ватт 08 - 25',

    tip4: 'Мы готовы сотрудничать с вами',

    cooperation: 'коммерческое сотрудничество',

    cooperation2: 'таланты рекомендуются рекомендуются',

    phone: 'контактный телефон',

    abus: 'заботиться о нас',

    tip5: 'микро - код',
  },
  news: {
    companynews: 'новости',

  },
  contactUs: {
    us: 'связаться с нами',

    company: 'о компании',

    news: 'news information',

    address: 'адрес компании',

    contact: 'связаться с нами',

    companyCondtion: 'Корпоративная среда',
    companyActivity: 'Деятельность компании',

    logo: 'международный средний воротник',

    message0: {
      message01: 'Гуандунская международная цепочка поставок с ограниченной ответственностью расположена в районе Байюнь, г. гуанчжоу, Китай, зарегистрированные средства в размере 20 млн. юаней, компания получила квалификацию первого класса экспедиторского Агентства, выданную министерством коммерции, имеет « международный судовой агент», « бескорабельный перевозчик» и специальные (упаковочные) разрешения на автомобильный транспорт и другие отрасли промышленности,В то же время является членом Ассоциации « континентальный мост» (крупнейшей в мире платформы для трансграничных перевозок в секторе международной железнодорожной логистики) и китайской ассоциации международных перевозок (Сифа).\n для того чтобы позитивно откликнуться на стратегическое решение и содействие страны один район, компания сосредоточила внимание на товарах из страны в Европу, россию и Центральную Азию, включая смешанные перевозки и складское хранение железнодорожных, морских, воздушных, морских и железных дорог и карт.В то же время, чтобы быстрее и лучше интегрироваться в международные связи, компания придерживается современной концепции логистики Интеграция управления производственно - сбытовыми цепочками, чтобы получить высококачественные услуги, чтобы завоевать доверие многих клиентов.\n компания имеет отличные профессиональные группы и эффективные и быстрые оперативные модели, в соответствии с принципами честности, безопасности, быстрых и профессиональных, для клиентов постоянно оптимизировать логистику различных звеньев, снизить логистические расходы, для внутренних и иностранных клиентов железной дороги, автомобильных, морских и таможенных деклараций, складирования, погрузки, хранения контейнеров и другие  общие логистические услуги, чтобы заложить хорошую основу для развития компании,постоянно предлагать клиентам лучшие решения.\n',
    },
    mission: 'our Mission',

    tip: 'честный, неограниченный',

    vision: 'наше видение',

    tip1: 'вспомогательное развитие логистики в районе',

    culture: 'корпоративная культура',

    Tip2: 'Мы быстро продвигаемся вперед',
    message1: {
      message10: 'инспекция в провинции гуандун',

      message11: 'министерство торговли министр Син инспекции',

      message12: 'инспекция секретаря провинциального комитета провинции гуандун',

      message13: 'промежуточный Международный и китайский контракт',
    },
    tip3: 'наша сеть быстро формируется',

    city1: 'Шэньчжэнь',

    add1: 'К. C1009, Э. 10, Корпус С, промышленный парк Hengboli Rongfeng, улица Xuegangbei, район Longhua, Шэньчжэнь',

    tip4: 'Мы готовы сотрудничать с вами',

    cooperation: 'коммерческое сотрудничество',

    cooperation2: 'таланты рекомендуются рекомендуются',

    phone: 'контактный телефон',

    abus: 'заботиться о нас',

    tip5: 'микро - код',
  },
  joinUs: {
    Environment: 'Корпоративная среда',
    place: 'служебная среда',
    tip: 'независимость широкого и светлого пространства',
    scene: 'павильон компании',
    tip1: 'холл будущего',

    Activities: 'Деятельность компании',
    annual: 'корпусное строительство',
    tip3: 'вместе совершить великие подвиги, подняться на вершину жизни',
    companyNewsTitle: 'информация',
    companyNews: 'Новости компании',
    companyNewsTip: 'Мы идем',
    message2: {
      message01: 'инспекция секретаря провинциального комитета Гуандуна',
      message02: 'инспекция провинции гуандун',
      message03: 'инспекция министра коммерции синя',
      message04: 'гуандунская пресса',
    },
  },
  bottom: {
    product: 'продукт компании',

    chip: 'интеллектуальный модуль',

    robot: 'интеллектуальный робот',

    terminal: 'интеллектуальный терминал',

    car: 'интеллектуальный патруль',

    entry: 'быстрый доступ',

    coreTechnology: 'основные технологии',

    news: 'Новости компании',

    solution: 'Наши услуги',

    aboutUs: 'о нас',

    contactUs: 'связаться с нами',

    joinUse: 'Campaign',

    partner: 'партнер',

    allVisited: 'общий доступ',
  },
  newSolutions: cn_solutions,
  newProducts: cn_products
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/ru.js